import { render, staticRenderFns } from "./StepCustomVariables.vue?vue&type=template&id=8370b534&scoped=true&"
import script from "./StepCustomVariables.vue?vue&type=script&lang=js&"
export * from "./StepCustomVariables.vue?vue&type=script&lang=js&"
import style0 from "./StepCustomVariables.vue?vue&type=style&index=0&id=8370b534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8370b534",
  null
  
)

export default component.exports